import React from 'react';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import PropTypes from 'prop-types';

function OrderFormPageHeader({ inspectionIcon, text, hideDateTime }) {
  return (
    <div className="flex w-full flex-wrap items-center px-[1vw] font-bold">
      <div className="w-8/12">
        <div
          className="flex items-center font-['Open_Sans'] font-bold text-[#212529]"
          style={{ fontSize: '16px', marginTop: '0.6vw', marginBottom: '0.6vw' }}
        >
          <span>{inspectionIcon}</span>
          <span>
            {typeof text === 'string' ? (
              <FormattedMessage id={text} defaultMessage="Novo Pedido" />
            ) : (
              text || <FormattedMessage id="orderForm.newOrder" />
            )}
          </span>
        </div>
      </div>

      {!hideDateTime && (
        <div
          className="w-4/12 text-right font-['Open_Sans'] font-bold text-[#212529]"
          style={{ fontSize: '14px' }}
        >
          <FormattedDate value={new Date()} />
          &nbsp; ● &nbsp;
          <FormattedTime value={new Date()} />
        </div>
      )}

      <div className="w-full">
        <hr style={{ display: 'block', border: 0, borderTop: '1px solid #E9E9E9', padding: 0 }} />
      </div>
    </div>
  );
}

OrderFormPageHeader.propTypes = {
  inspectionIcon: PropTypes.object,
  text: PropTypes.string,
  hideDateTime: PropTypes.bool,
};

OrderFormPageHeader.defaultProps = {
  text: 'orderForm.newOrder',
  hideDateTime: false,
};

export default OrderFormPageHeader;
